import { RootState } from "modules";
import { TeacherPupilsState } from ".";

export const selectTeacherPupils = (state: RootState): TeacherPupilsState =>
  state.teacherPupils